import { Component, inject, effect, signal, untracked } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-top-loader',
  standalone: true,
  template: `
    <div class="top-loader">
      <div class="top-loader__bar"
           [class.top-loader__bar--active]="loader.isLoading()"
           [class.top-loader__bar--done]="done()">
      </div>
    </div>
  `,
  styles: [`
    .top-loader {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      z-index: 9999;
      pointer-events: none;
    }

    .top-loader__bar {
      height: 100%;
      width: 0%;
      opacity: 0;
      background: #6366f1;
      border-radius: 0 2px 2px 0;
      box-shadow: 0 0 8px rgba(99, 102, 241, 0.6);
    }

    .top-loader__bar--active {
      opacity: 1;
      animation: loader-grow 5s cubic-bezier(0.1, 0.4, 0.2, 1) forwards;
    }

    @keyframes loader-grow {
      0%   { width: 0%;  }
      20%  { width: 50%; }
      60%  { width: 75%; }
      80%  { width: 85%; }
      100% { width: 90%; }
    }

    .top-loader__bar--done {
      animation: none !important;
      width: 100% !important;
      opacity: 0 !important;
      transition: width 0.15s ease,
                  opacity 0.3s ease 0.2s !important;
    }
  `]
})
export class TopLoader {
  loader = inject(LoaderService);
  done   = signal(false);

  constructor() {
    effect(() => {
      const loading = this.loader.isLoading();

      // untracked — setTimeout callback runs outside the effect's reactive context,
      // preventing NG0100 by ensuring the signal write happens in the next CD cycle
      untracked(() => {
        if (!loading) {
          this.done.set(true);
          setTimeout(() => this.done.set(false), 600);
        } else {
          this.done.set(false);
        }
      });
    });
  }
}